/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
    },
    registered (registration) {
      
      // Vérifier les mises à jour toutes les heures
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60)
    },
    cached () {
    },
    updatefound () {
    },
    updated (registration) {
      
      // Notifier l'utilisateur qu'une nouvelle version est disponible
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline () {
    },
    error (error) {
      console.error('❌ Error during service worker registration:', error)
    }
  })
}

// Gérer l'événement beforeinstallprompt pour le bouton d'installation
// eslint-disable-next-line no-unused-vars
let deferredPrompt
window.addEventListener('beforeinstallprompt', (e) => {
  // Empêcher l'affichage automatique de la mini-infobar
  e.preventDefault()
  // Stocker l'événement pour l'utiliser plus tard
  deferredPrompt = e
  
  // Notifier l'application que la PWA peut être installée
  window.dispatchEvent(new CustomEvent('pwaInstallable', { detail: e }))
})

// Détecter si l'app a été installée
window.addEventListener('appinstalled', () => {
  deferredPrompt = null
})
